/**
 * Default state for components atom.
 * Shared between componentsAtom and defaultComponentsAtom to avoid duplication.
 */
export const DEFAULT_COMPONENTS_STATE = {
  load: {
    componentAttributes: {
      loadParameters: {
        profileDetail: {
          file: null,
          startTime: "00:00",
          startDate: null,
          timeResolution: 15,
          units: "kW",
          uploadLoadFile: "",
          profileDataLoc: "OfficeMedium",
          scalingFactor: "1",
          useThermalLoad: false,
          thermalFile: null,
          isThermalFileClicked: false,
          isLoadFileClicked: false,
        },
        profileFile: [],
      },
    },
  },
  grid: {
    componentAttributes: {
      gridParameters: {
        co2Emission: {
          type: "Fixed",
          gridEmissionFactor: "450",
        },
        // powerImport: "1",
        powerExport: {
          condition: "No Export",
          percentage: "0",
        },
        powerImport: {
          condition: "Unlimited Import",
          value: "0",  
        },
        outageEvent: "",
        outageStartDate: "",
        outageEndDate: "",
        outageDates: [],
      },
    },
    economicAttributes: {
      gridParameters: {
        price: "110",
        newInstallationCost: "600",
        omCost: "2",
      },
    },
    uiAttributes: {
      tariffType: "static",
      gridParameters: {
        co2Weight: "0",
        co2Optimization: false,
        demandReset: "0",
        demandManagement: {
          type: "none",
          value: "0",
        },
        timeOfUseOptimization: true,
        optimizeDemandResponse: false,
        outageOccurDuration: {
          backup: "fullBackUp",
          loadValue: 100,
        },
        operationCapitalCost: false,
        addOutageManageLoad: false,
      },
    },
  },
  pv: {
    componentName: "",
    uiAttributes: {
      pvParameters: {
        pvSetup: "new",
        isUploadPV: false,
      },
    },
    componentAttributes: {
      pvParameters: {
        profileFile: [],
        createProfileData: [],
        profileDetail: {
          name: "",
          startDate: null,
          startTime: "00:00",
          timeResolution: 15,
          units: "kW",
        },
        relDCPower: "",
        invEfficiency: "",
        relACPower: "",
        tilt: "",
        orientation: "",
        systemLoss: "",
        powNom: "",
        powNomRef: "",
        degradationFactor: "",
        isUploadPvFileButtonClicked: false,
        createProfileButtonClicked: false,
      },
    },
    economicAttributes: {
      pvParameters: {
        pvOmCost: "",
        pvCapexCost: "",
        pvLifetime: "",
        invOmCost: "",
        invCapexCost: "",
        invLifetime: "",
      },
    },
    incentives: [],
  },

  battery: {
    componentAttributes: {
      batteryParameters: {
        CapaMax: "",
        DegradationFactor: "1",
        EfficiencyCharge: "",
        EfficiencyDischarge: "",
        SOCMax: "",
        SOCMin: "",
        MaximumCharge: "",
      },
    },
    economicAttributes: {
      batteryParameters: {
        LifetimeCycle: "",
        CAPEX: "",
        Replacement: "",
        OM: "",
        InflationRate: "2",
      },
    },
    uiAttributes: {
      batteryParameters: {
        selectBattery: "",
        exportPrice: "",
        assetId: 0,
        chargingMethod: "No Constraint",
        lifetimeInYears: "",
        annualChargeCycle: "200",
        setupControlParameter: false,
        incentiveActive: false,
      },
    },
    incentives: [],
  },
  genset: {
    componentAttributes: {
      gensetParameters: {
        PowElecNom: 100,
        DegradationFactor: 1,
        MinPowerRate: 30,
        FuelCurveSlope: 0.00029,
        FuelCurveIntercept: 0.0005,
        MinimumRunTime: 300,
        PowerProfile: "Power",
        HeatRecoveryRatio: 0,
        PowerReserve: 30,
        Fuel: {
          Name: "Diesel",
          PricePerM3: "",
          LHV: "43.2",
          Density: "820",
          Carbon: "88",
        },
        NbGenset: 1,
        GensetType: "BaseloadGenset",
      },
    },
    economicAttributes: {
      gensetParameters: {
        LifetimeYear: 15,
        LifetimeHour: 15000,
        CAPEX: 250,
        Replacement: 250,
        OM: 2,
        InflationRate: 2,
      },
    },
    uiAttributes: {
      gensetParameters: {
        assetId: 0,
        selectGenset: "",
        gensetEconomicOptimization: false,
      },
    },
    incentives: [],
  },
  currentComponent: "load",

  evcs: {
    componentAttributes: {
      evcsParameters: {
        profileDetail: {
          componentType: "EVCS",
          recurrence: "YEARLY",
          profileFileName: null,
          startDate: null,
          startTime: "00:00",
          timeResolution: 15,
          units: "kW",
          profileDataLoc: null,
        },
        profileFile: [],
      },
    },
    economicAttributes: {
      evcsParameters: {
        CAPEX: 0,
        Replacement: 0,
        OM: 0,
        LifetimeYear: 0,
      },
    },
    datasource: "Upload",
  },
  controller: {
    componentAttributes: {
      controllerParameters: {
        mainAnchor: null,
        exportPowerBattery: false,
        exportPowerGenset: false,
      },
    },
    economicAttributes: {
      controllerParameters: {
        lifetimeYear: "",
        capex: "",
        replacement: "",
        om: "",
        detailedCapex: [],
      },
    },
    datasource: "OTHER",
  },
};

/**
 * Always returns a deep-cloned copy of DEFAULT_COMPONENTS_STATE.
 * Use this instead of the raw object to prevent shared-reference mutations
 * from corrupting resets across project switches.
 */
export const getDefaultComponentsState = () =>
  JSON.parse(JSON.stringify(DEFAULT_COMPONENTS_STATE));
